import axios from 'axios';

export const SET_CART = 'SET_CART';
export const ADD_ITEM_CART = 'ADD_ITEM_CART';
export const REMOVE_ITEM_CART = 'REMOVE_ITEM_CART';
export const REMOVE_ITEM_ALL_CART = 'REMOVE_ITEM_ALL_CART';

export function setCart(payload) {
    return {
        type: SET_CART,
        payload: payload
    };
}

export function addItem(item, size, color) {
    return {
        type: ADD_ITEM_CART,
        item: item,
        color: color,
        size: size
    };
}

export function removeItem(item, size, color) {
    return {
        type: REMOVE_ITEM_CART,
        item: item,
        color: color,
        size: size
    };
}

export function removeAllItems() {
    return {
        type: REMOVE_ITEM_ALL_CART
    };
}

export const fetchCart = () => {
    return dispatch => {
        axios.get(`${process.env.REACT_APP_API_KEY}/carts?token=${localStorage.getItem("token")}`)
        .then(res => {
            dispatch(setCart(res.data));
        }).catch(err => {
            console.log(err.response.data.error.message);
        });
    };
}

export const addToCart = (id, size, color) => {
    return dispatch => {
        if (localStorage.getItem("visitor") === "true") {
            dispatch(addItem(id, size, color));
        }
        else {
            axios.post(`${process.env.REACT_APP_API_KEY}/carts`,
            {
                product_id: id,
                product_size: size,
                product_color: color
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Token ${localStorage.getItem("token")}`
                }
            })
            .then(res => {
                dispatch(addItem(id, size, color));
            }).catch(err => {
                console.log(err.response.data.error.message);
            });
        }
    };
}

export const removeFromCart = (id, size, color) => {
    return dispatch => {
        if (localStorage.getItem("visitor") === "true") {
            dispatch(removeItem(id, size, color));;
        }
        else {
            axios.delete(`${process.env.REACT_APP_API_KEY}/carts`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Token ${localStorage.getItem("token")}`
                },
                data: {
                    product_id: id,
                    product_size: size,
                    product_color: color
                }
            })
            .then(res => {
                dispatch(removeItem(id, size, color));
            }).catch(err => {
                console.log(err.response.data.error.message);
            });
        }
    };
}

export const clearCart = () => {
    return dispatch => {
        dispatch(removeAllItems());
    };
}